export default __webpack_public_path__ + "static/media/male-ectomorph.187b2f9a.svg";